<template>
  <div class="role-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>系统平台</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.platform" class="app-block" placeholder="请选择系统平台">
              <a-select-option :value="1">IOS</a-select-option>
              <a-select-option :value="2">Android</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>终端</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.terminal" class="app-block" placeholder="请选择终端">
              <a-select-option value="owner">客户端</a-select-option>
              <a-select-option value="property">物业端</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newVersion()">新增版本</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editVersion(data)">编辑</a-button>
          <a-button type="link" @click="deleteVersion(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
  import VersionService from '@/io/version.js';

  export default {
    name: 'VersionManage',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            platform: [],
            terminal: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '版本号',
              dataIndex: 'version'
            },
            {
              title: '系统平台',
              dataIndex: 'platformText'
            },
            {
              title: '更新类型',
              dataIndex: 'updateStateText'
            },
            {
              title: '终端',
              dataIndex: 'terminalText'
            },
            {
              title: '发布时间',
              dataIndex: 'publish_time'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
    activated() {
      this.initData();
    },
    methods: {
      newVersion() {
        this.table.page.current = 1;
        this.$router.push('/platform/version_manage/new');
      },
      editVersion(data) {
        this.$router.push(`/platform/version_manage/edit/${data.id}`);
      },
      deleteVersion(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此版本？',
          onOk() {
            VersionService.del(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          platform: [],
          terminal: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return VersionService.listPage(
          this.table.search.platform,
          this.table.search.terminal,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.platformText = val.platform === 1 ? '苹果' : '安卓';
            val.updateStateText = val.update_state === 1 ? '必须' : '非必须';
            val.terminalText = val.terminal === 'owner' ? '住户端' : '物业端';
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>